module.exports = __webpack_public_path__ + "img/difengxian.586ab7b8.png";